class EventEmitter extends EventTarget {
    logOut = () => {
        this.dispatchEvent(new Event('logOut'));
    };
}

export default new EventEmitter();
